import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthMethod, useAuthUser } from '../../../../../@lbs/hook/AuthHooks';
import { Fonts } from '../../../../constants/AppEnums';

type CustomUserInfoProps = {
    color?: string;
};

const CustomUserInfo: React.FC<CustomUserInfoProps> = ({
    color = 'text.secondary',
}) => {
    const { logout } = useAuthMethod();
    const { user } = useAuthUser();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Box
                onClick={handleClick}
                sx={{
                    py: 3,
                    px: 3,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                className='user-info-view'
            >
                <Box
                    sx={{
                        mb: 0,

                        fontSize: 16,
                        fontWeight: Fonts.MEDIUM,
                        color: 'inherit',
                    }}
                    component='span'
                >
                    {user?.displayName ?? 'Admin User'}
                </Box>

                <Box
                    sx={{
                        ml: 3,
                        color: 'inherit',
                        display: 'flex',
                    }}
                >
                    <ExpandMoreIcon />
                </Box>
            </Box>
            <Menu
                id='simple-menu'
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        navigate('/change-password');
                    }}
                >
                    Change Password
                </MenuItem>
                <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
        </>
    );
};

export default CustomUserInfo;
